import { SvgBox, SvgBoxProps } from "@govlaunch/web";
import React from "react";

export default function GovernmentsStackIcon(props: SvgBoxProps) {
  return (
    <SvgBox width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx={12} cy={12} r={10.75} fill="#fff" stroke="#3F4A5A" strokeWidth={2.5} />
      <mask id="fa4wiuwai4wau4" fill="#fff">
        <rect x={5.539} y={8.308} width={12.923} height={9.231} rx={1} />
      </mask>
      <rect
        x={5.539}
        y={8.308}
        width={12.923}
        height={9.231}
        rx={1}
        fill="#fff"
        stroke="#3F4A5A"
        strokeWidth={3.4}
        mask="url(#fa4wiuwai4wau4)"
      />
      <path stroke="#3F4A5A" strokeLinecap="round" d="M7.885 6.885h8.231M9.731 5.038h4.538" />
    </SvgBox>
  );
}
